import * as React from 'react';
//import { useTheme } from '@mui/material/styles';
//import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles';
//import { el } from 'date-fns/locale';

// Generate Sales Data
// function createData(time, amount) {
//   return { time, amount };
// }

// const data = [
//   createData('00:00', 0),
//   createData('03:00', 300),
//   createData('06:00', 600),
//   createData('09:00', 800),
//   createData('12:00', 1500),
//   createData('15:00', 2000),
//   createData('18:00', 2400),
//   createData('21:00', 2400),
//   createData('24:00', undefined),
// ];

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      root: {  //This can be referred from Material UI API documentation. 
        padding: '0px 4px',
        // backgroundColor: "#eaeaea",
      },
    },
  },
});

const ReviewCard = (props) => {
  //export default function RequestCard(title) {
  //const theme = useTheme();
  //debugger;

  // console.log(props);
  if (!props.rows) {

    return (<Title>{props.title}</Title>);
  }
  else {
    return (
      <React.Fragment>
        <ThemeProvider theme={theme}>
          <Title>{props.title}</Title>
          <Paper
            style={{ maxHeight: 200, overflow: 'auto' }}
          >

            <Table  >
              <TableHead >
                <TableRow>
                  <TableCell style={{ width: '15%' }} align="left">Name</TableCell>
                  <TableCell style={{ width: '15%' }} align="left">Eol Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.rows.map(row => (
                  <TableRow key={row.id}>
                    <TableCell component="th" scope="row">
                      {row.hostname}
                    </TableCell>
                    <TableCell align="left">{row.eoldate}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}
export default ReviewCard;